import React from 'react';
import PropTypes from 'prop-types';
import handleGalleryThumbnailClick from '../actions/handleGalleryThumbnailClick';

const CollectionItemModalGallery = ({gallery, setModalContent, mainImgSrc, currentModalItemIndex}) => {

	const placeholderImgSrc = `${mainScript.assetPath}images/png/placeholder/bmo-portrait-placeholder.png`;

	if (!gallery.length) return null;
	return (
		<div className='modal__related-images' 
			onClick={event => {handleGalleryThumbnailClick(event, setModalContent, currentModalItemIndex, mainImgSrc)}}
		>
			{
				gallery.map((galleryImage) => {
					const values = {
						image: galleryImage.image ? galleryImage.image : placeholderImgSrc,
						altText: galleryImage.alt_text ? galleryImage.alt_text : '',
					}
					return (
						<button key={galleryImage.id} className='modal__related-image' aria-label="View related image">
							<div className='aspect-ratio-box'>
								<img src={values.image} alt={values.altText} data-id={galleryImage.id}/>
							</div>
						</button>
					)
				})
			}
		</div>
	)
}

export default CollectionItemModalGallery;

CollectionItemModalGallery.propTypes = {
	gallery: PropTypes.array,
	mainImgSrc: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.bool,
	]),
	setModalContent: PropTypes.func,
	currentModalItemIndex: PropTypes.number,
}